import { Timestamp } from "firebase/firestore";

export interface Sonho {
  id?: string;
  title: string;
  createdAt?: Timestamp;
  local: string;
  imagesUrl: string[];
}

export interface Pacote {
  id?: string;
  title: string;
  createdAt?: Timestamp;
  data_partida: string;
  data_retorno: string;
  imagesUrl: string[];
  local: string;
  preco: string;
  tipo_transporte: string;
  descricao: string;
  tag: string;
}

export interface Formulario {
  id?: string;
  acomodacao: string;
  atividade: string;
  data_partida: string;
  data_retorno: string;
  destino_desejado: string;
  email: string;
  flexbilidade: string;
  quais_data?: string;
  quantos_adulto?: string;
  quantas_criancas?: string;
  info_adc: string;
  name: string;
  orcamento: string;
  restricao_alimentar: string;
  telefone: string;
  tipo_viagem: string;
  createdAt?: Timestamp;
}

export interface Atividade {
  id?: string;
  atividade: string;
  createdAt?: Timestamp;
}

export interface Fornecedores {
  id?: string;
  createdAt?: Timestamp;
  descricao?: string;
  email: string;
  empresa?: string;
  nome: string;
  telefone?: string;
}

export interface User {
  uid: string;
  createdAt?: Timestamp;
}

export enum AppRoutes {
  dashboard = "/admin/dashboard",
  pesquisa = "/admin/dashboard/pesquisa",
  pacotes = "/admin/dashboard/pacote",
  usuarios = "/admin/dashboard/usuarios",
  fornecedores = "/admin/dashboard/fornecedores",
  viagens = "/admin/dashboard/sonhos-realizados",
}

export interface MenuItens {
  name: string;
  icon: JSX.Element;
  route: string;
}
